export const mobileSize = 820;
